import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { EpidemiologyApi, EpidemiologyPrevProjApi } from "./ops";
import { formatOptionsBody } from "../../utils/formToOptsBody";
import { formatPrevProjOptionsBody } from "api/utils/formToPrevProjBody";

export const epidemiologyKeys = {
  all: ["epidemiology"] as const,
  details: (locCode: number, optionsKey: string) =>
    [...epidemiologyKeys.all, "details", locCode, optionsKey] as const,
};

export function useEpidemiologyByLocCodeAndOptions(locCode: number, options?: any) {
  const optionsBody = formatOptionsBody(options ?? null);
  const optionsKey = JSON.stringify(optionsBody);

  return useQuery({
    queryKey: epidemiologyKeys.details(locCode, optionsKey),
    queryFn: ({ signal }) => {
      if (!locCode) throw new Error("locCode is required");
      return EpidemiologyApi.postByLocCodeAndOptions(locCode, optionsBody, signal);
    },
    enabled: !!locCode,
  });
}

export const prevProjKeys = {
  all: ["prevProj"] as const,
  details: (locCode: number, optionsKey: string) =>
    [...prevProjKeys.all, "details", locCode, optionsKey] as const,
};

export function usePrevProjDataByLocCodeAndOptions(locCode: number, options?: any) {
  const optionsBody = formatPrevProjOptionsBody(options ?? null);
  const optionsKey = JSON.stringify(optionsBody);

  return useQuery({
    queryKey: prevProjKeys.details(locCode, optionsKey),
    queryFn: ({ signal }) => {
      if (!locCode) throw new Error("locCode is required");
      return EpidemiologyPrevProjApi.postByLocCodeAndOptions(locCode, optionsBody, signal);
    },
    enabled: !!locCode,
  });
}
